import { createBackgroundLoaderContext } from "contexts";
import { Mappable } from "models";

export const MappableContext = createBackgroundLoaderContext<Mappable>();
